<template>
    <div>
        <label :style="'color:' + fieldsColor">
            {{ field.name }}
        </label>
        <v-autocomplete
          v-model="currentApidaeContact.commune"
          :items="contactCommunes"
          item-text="name"
          return-object
          :loading="loadingCommunes"
          :search-input.sync="search"
          no-data-text="Saisissez pour sélectionner une ville"
          outlined
          :readonly="readOnly"
          hide-details>
        </v-autocomplete>
    </div>
</template>

<script>
import {mapState, mapMutations} from "vuex"
import _ from "lodash"

export default {
    name: "FormContactCity",
    props: ['field'],
    data() {
        return {
            loadingCommunes: false
        }
    },
    methods: {
        ...mapMutations('web_form', ['setContactCommunes', 'pushContactCommune', 'setSearchContactCommunes',]),
        getCommunes: _.debounce(function () {
            this.loadingCommunes = true
            let providerId

            if(this.$route.params.providerId !== undefined) {
                providerId = this.$route.params.providerId
            } else {
                providerId = this.provider.id
            }

            let payload = {
                search: this.searchContactCommunes,
                providerId: providerId,
            }

            this.$http.post('resource/communes', payload).then(res => {
                this.setContactCommunes(res.body.data.communes)
                this.loadingCommunes = false
            })
        }, 500)
    },
    watch: {
        searchContactCommunes() {
            if (this.searchContactCommunes) {
                this.setSearchContactCommunes(this.searchContactCommunes.toUpperCase())
            } else {
                this.setSearchContactCommunes(null)
                this.currentApidaeContact.commune = null
            }

            this.getCommunes()
        },
    },
    mounted() {
        if (this.currentApidaeContact &&
          this.currentApidaeContact.commune !== undefined && this.currentApidaeContact.commune !== null) {
            this.pushContactCommune(this.currentApidaeContact.commune)
            this.setSearchContactCommunes(this.currentApidaeContact.commune.name)
        }
    },
    computed: {
        ...mapState("webFormStyle", ["fieldsColor", 'primaryColor']),
        ...mapState("web_form", [
          'submitted',
            'provider',
            'contactCommunes',
            'searchContactCommunes',
            'readOnly',
            'currentApidaeContact',
        ]),
        search: {
            get () {
                return this.searchContactCommunes
            },

            set (searchInput) {
                this.setSearchContactCommunes(searchInput)
            }
        }
    }
}
</script>